import { render, staticRenderFns } from "./yearrain.vue?vue&type=template&id=124fe514&scoped=true&"
import script from "./yearrain.vue?vue&type=script&lang=js&"
export * from "./yearrain.vue?vue&type=script&lang=js&"
import style0 from "@/assets/monitor.less?vue&type=style&index=0&id=124fe514&lang=less&scoped=true&"
import style1 from "./yearrain.vue?vue&type=style&index=1&id=124fe514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fe514",
  null
  
)

export default component.exports